<div class="camera-modal-overlay" *ngIf="isVisible" (click)="close()">
    <div class="camera-modal-container" role="dialog" aria-modal="true"
        [attr.aria-label]="'tireScanner.title' | translate" (click)="$event.stopPropagation()">
        <div class="camera-modal-header">
            <div class="camera-header-info">
                <h3>{{ 'tireScanner.title' | translate }}</h3>
                <span class="photos-counter" *ngIf="detectedDimension">
                    {{ detectedDimension }}
                </span>
            </div>
            <button type="button" class="close-modal-btn" (click)="close()"
                [attr.aria-label]="'protocol_orders.close' | translate">×</button>
        </div>

        <div class="camera-viewer">
            <video #cameraVideo autoplay playsinline muted [hidden]="!cameraStream || !!imagePreview"
                class="camera-video" [attr.aria-hidden]="!cameraStream || !!imagePreview">
            </video>
            <canvas #cameraCanvas style="display: none;"></canvas>
            <div class="image-preview-container" *ngIf="imagePreview">
                <img [src]="imagePreview" [alt]="'tireScanner.changeImage' | translate" class="camera-video" />
            </div>
            <div class="camera-placeholder" *ngIf="!cameraStream && !imagePreview">
                <div class="camera-icon" *ngIf="!cameraLoading && !cameraError && !isScanning">
                    <img src="assets/icons/camera.svg" alt="" />
                </div>
                <div class="camera-loading" *ngIf="cameraLoading">
                    <div class="spinner"></div>
                    <p>{{ 'protocol_orders.loadingCamera' | translate }}</p>
                </div>
                <div class="camera-loading" *ngIf="isScanning && !imagePreview">
                    <div class="spinner"></div>
                    <p>{{ 'tireScanner.scanningTire' | translate }}</p>
                </div>
                <div class="camera-error" *ngIf="cameraError">
                    <p>{{ cameraError }}</p>
                    <button type="button" (click)="retryCamera()" class="btn btn-primary">
                        {{ 'protocol_orders.retryCamera' | translate }}
                    </button>
                </div>
                <p *ngIf="!cameraLoading && !cameraError && !isScanning">{{ 'tireScanner.uploadHint' | translate }}</p>
                <p class="camera-instructions" *ngIf="!cameraLoading && !cameraError && !isScanning">
                    {{ 'tireScanner.uploadImage' | translate }}
                </p>
            </div>
            <button type="button" *ngIf="cameraStream && hasMultipleCameras && !imagePreview" class="btn-switch-camera"
                (click)="switchCamera()" [disabled]="cameraLoading">
                <img src="assets/icons/video-camera-travel.svg" alt="" />
                {{ 'protocol_orders.switchCamera' | translate }}
            </button>
            <button type="button" *ngIf="imagePreview && !isScanning" class="btn-switch-camera"
                (click)="reset(); open()">
                <img src="assets/icons/video-camera-travel.svg" alt="" />
                {{ 'tireScanner.changeImage' | translate }}
            </button>
        </div>

        <div class="results-panel" *ngIf="detectedDimension && !isScanning && tireInfo">
            <div class="detected-tire-card">
                <div class="tire-dimension-badge success">
                    <span class="dimension-text">{{ detectedDimension }}</span>
                </div>
            </div>
        </div>

        <div class="no-results-panel" *ngIf="!detectedDimension && !isScanning && imagePreview">
            <div class="camera-error">
                <p>{{ 'tireScanner.noDimensionFound' | translate }}</p>
                <button type="button" (click)="reset(); open()" class="btn btn-primary">
                    {{ 'tireScanner.takeNewPhoto' | translate }}
                </button>
            </div>
        </div>

        <div class="camera-modal-controls">
            <button type="button" class="btn-camera-action btn-skip" (click)="close()" *ngIf="!detectedDimension">
                <img src="assets/icons/x.svg" alt="" />
                {{ 'common.cancel' | translate }}
            </button>
            <button type="button" class="btn-camera-action btn-capture" (click)="capturePhoto()"
                [disabled]="!canCapture" *ngIf="cameraStream && !imagePreview && !detectedDimension">
                <img src="assets/icons/photograph.svg" alt="" />
                {{ 'protocol_orders.cameraModalCapture' | translate }}
            </button>
            <button type="button" class="btn-camera-action btn-capture" (click)="fileInput.click()"
                [disabled]="isScanning" *ngIf="canUpload">
                <img src="assets/icons/photograph.svg" alt="" />
                {{ 'tireScanner.uploadImage' | translate }}
            </button>
            <button type="button" class="btn-camera-action btn-capture" (click)="scanTire()"
                [disabled]="isScanning || !imagePreview" *ngIf="canScanCurrentImage">
                <img src="assets/icons/camera.svg" alt="" />
                {{ 'tireScanner.retryWithSameImage' | translate }}
            </button>
            <button type="button" class="btn-camera-action btn-cancel" (click)="useDimension()"
                *ngIf="detectedDimension && !isScanning">
                <img src="assets/icons/check.svg" alt="" />
                {{ 'tireScanner.useDimension' | translate }}
            </button>
            <button type="button" class="btn-camera-action btn-skip" (click)="reset(); open()"
                *ngIf="showRetryWithNewCapture">
                <img src="assets/icons/video-camera-travel.svg" alt="" />
                {{ 'tireScanner.retry' | translate }}
            </button>
        </div>
        <input #fileInput type="file" accept="image/*" capture="environment" style="display: none;"
            (change)="onFileSelected($event)" [disabled]="isScanning" />
    </div>
</div>